// Native
import { Box, HStack, Image, Separator, Stack, Text } from "@chakra-ui/react"
import { useNavigate, useLocation } from "react-router"

// Custom
import { UI } from "components"
import { useData } from "hooks/useData"
import useDistributor from "hooks/useDistributor"
import { useState } from "react"

export default function Nav() {

    const { drawer, closeDrawer } = useData()

    return (
        <>
            <Menu />
            <UI.Drawer size="xs" placement="start" open={drawer} onClose={closeDrawer}>
                <Menu />
            </UI.Drawer>
        </>
    )
}

const Menu = () => {

    const distributor = useDistributor()
    const currentYear = new Date().getFullYear()

    return (
        <Box maxH="100%" overflowX="hidden">

            {/* Logo — py={4} espelha o Header para alinhar os separadores horizontalmente */}
            <HStack gap={3} px={4} py={4}>
                <Image src="/icon.png" h="32px" />
                <Box>
                    <Text fontWeight="bold" lineHeight="1">Bonífica</Text>
                    <Text fontSize="xs" color="fg.muted" mt={0.5}>Escritório de núcleo</Text>
                </Box>
            </HStack>

            <Separator />

            <Stack gap={4} p={4}>

                {/* Núcleo ativo */}
                <Box bg="bg.subtle" borderRadius={8} px={3} py={2.5}>
                    <Text fontSize="2xs" color="fg.subtle" fontWeight="semibold" textTransform="uppercase" letterSpacing="widest" mb={0.5}>
                        Núcleo ativo
                    </Text>
                    <Text fontSize="sm" fontWeight="semibold" lineHeight="1.3">
                        {distributor.data?.name ?? '—'}
                    </Text>
                </Box>

                <Separator />

                <UI.Show visible>
                    <Stack gap={0.5}>
                        <MenuItem path="/" title="Início" icon="home" />

                        <Separator my={1} />

                        <MenuItem path="/pedidos" title="Vendas" icon="orders" />

                        <MenuGroup title="Relatórios" icon="reports">
                            <MenuItem path="/relatorio/geral"      title="Relatório Geral"          icon="report-general" />
                            <MenuItem path="/relatorio/financeiro" title="Resumo Financeiro"         icon="withdraw"       />
                            <MenuItem path="/relatorio/vendidos"   title="Mais Vendidos"             icon="best-selling"   />
                            <MenuItem path="/relatorio/clientes"   title="Maiores Clientes"          icon="more-client"    />
                        </MenuGroup>

                        <Separator my={1} />

                        <MenuItem path="/compras"   title="Minhas compras" icon="cart"      />
                        <MenuItem path="/estoque"   title="Estoque"        icon="inventory" />
                        <MenuItem path="/loja"      title="Loja"           icon="store"     />

                        <Separator my={1} />

                        <MenuItem path="/perfil"    title="Meu núcleo"     icon="profile"   />
                        <MenuItem path="/financeiro" title="Financeiro"    icon="withdraw"  />
                        <MenuItem path="/ajustes"   title="Ajustes"        icon="settings"  />

                        <Box
                            w="100%"
                            py={2}
                            px={4}
                            cursor="pointer"
                            borderRadius={4}
                            backgroundColor={{base: 'bg.muted', _hover: 'orange.400'}}
                            color={{base: 'orange.500', _hover: 'white'}}
                            borderLeftWidth={2}
                            borderLeftColor={'orange.300'}
                            onClick={() => window.$chatwoot?.toggle()}
                        >
                            <HStack>
                                <UI.Icon name="support"/>
                                <Text fontSize="sm" fontWeight="medium">Atendimento Online</Text>
                            </HStack>
                        </Box>
                    </Stack>
                </UI.Show>

                <Separator />

                <Text fontSize="2xs" color="fg.subtle" lineHeight="1.6">
                    © Bonífica {currentYear}<br />
                    Versão 250609.2301
                </Text>

            </Stack>
        </Box>
    )
}

const MenuItem = ({ title, icon, path, colorPalette = 'orange', ...props }) => {

    const location = useLocation()
    const navigate = useNavigate()
    const { closeDrawer } = useData()

    const active = path === location.pathname

    const handleNavigate = path => {
        navigate(path)
        closeDrawer()
    }

    return (
        <Box
            w="100%"
            py={2}
            px={4}
            cursor="pointer"
            borderRadius={4}
            backgroundColor={{base: active ? 'bg.muted' : null, _hover: `${colorPalette}.400`}}
            color={{base: null, _hover: 'white'}}
            borderLeftWidth={2}
            borderLeftColor={active ? `${colorPalette}.300` : 'transparent'}
            onClick={() => handleNavigate(path)}
            {...props}
        >
            <HStack>
                <UI.Icon name={icon} color={active ? `${colorPalette}.100` : null}/>
                <Text fontSize="sm" color={active ? null : 'fg.muted'}>{title}</Text>
            </HStack>
        </Box>
    )
}

const MenuGroup = ({ title, icon, children, colorPalette = "orange" }) => {

    const [open, setOpen] = useState(false)

    return (
        <Box>
            <Box
                w="100%"
                py={2}
                px={4}
                cursor="pointer"
                borderRadius={4}
                backgroundColor={{base: null, _hover: `${colorPalette}.400`}}
                color={{base: null, _hover: 'white'}}
                borderLeftWidth={2}
                borderLeftColor={'transparent'}
                onClick={() => setOpen(!open)}
            >
                <HStack justify="space-between">
                    <HStack>
                        <UI.Icon name={icon}/>
                        <Text fontSize="sm" color="fg.muted">{title}</Text>
                    </HStack>
                    <UI.Icon
                        name={open ? "double-chevron-up" : "double-chevron-down"}
                        boxSize={3}
                    />
                </HStack>
            </Box>

            {open && (
                <Stack
                    pl={4}
                    ml={2}
                    mt={0.5}
                    borderLeftWidth="1px"
                    borderLeftColor="border"
                    gap={0.5}
                >
                    {children}
                </Stack>
            )}
        </Box>
    )
}
